export let CompanySizeOption;
(function (CompanySizeOption) {
  CompanySizeOption["One"] = "one";
  CompanySizeOption["TwoToFive"] = "twoToFive";
  CompanySizeOption["SixToTen"] = "sixToTen";
  CompanySizeOption["ElevenToTwentyFive"] = "elevenToTwentyFive";
  CompanySizeOption["TwentySixToFifty"] = "twentySixToFifty";
  CompanySizeOption["FiftyOneToOneHundred"] = "fiftyOneToOneHundred";
  CompanySizeOption["OneHundredOneToTwoHundred"] = "oneHundredOneToTwoHundred";
  CompanySizeOption["TwoHundredOneToFiveHundred"] = "twoHundredOneToFiveHundred";
  CompanySizeOption["FiveHundredOneOrMore"] = "fiveHundredOneOrMore";
})(CompanySizeOption || (CompanySizeOption = {}));